export enum ReviewGender {
  MALE = "male",
  FEMALE = "female",
  THEM_THEY = "them/they",
}
